import React from "react";
import AcUnitOutlinedIcon from "@mui/icons-material/AcUnitOutlined";
import LocalPizzaOutlinedIcon from "@mui/icons-material/LocalPizzaOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import KitchenOutlinedIcon from "@mui/icons-material/KitchenOutlined";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import dominos from "../assets/brands/dominos.png";
import popeyes from "../assets/brands/popeyes.png";
import dunkin from "../assets/brands/dunkin.png";
import hongsKitchen from "../assets/brands/hongs-kitchen.png";
import "./LoginArtwork.css";

const BRANDS = [
  { name: "Domino's", logo: dominos },
  { name: "Popeyes", logo: popeyes },
  { name: "Dunkin'", logo: dunkin },
  { name: "Hong's Kitchen", logo: hongsKitchen },
];

// Illustrative only: a store's energy draw over a day, with the lunch and
// dinner rushes. Drawn in a 300 x 100 box.
const CHART_LINE =
  "M0 82 L20 80 L40 78 L60 70 L80 52 L100 30 L120 26 L140 40 L160 58 L180 60 L200 44 L220 18 L240 12 L260 28 L280 58 L300 74";

// The welcome-side illustration on the login page: a few dashboard cards
// floating over soft brand-coloured shapes.
export function LoginArtwork() {
  return (
    <div className="loginArt">
      <div className="loginArtBlob loginArtBlobSky" />
      <div className="loginArtBlob loginArtBlobGreen" />
      <div className="loginArtDots" />

      <div className="loginArtChip loginArtChipOven" title="Ovens">
        <LocalPizzaOutlinedIcon />
      </div>
      <div className="loginArtChip loginArtChipAc" title="Air conditioning">
        <AcUnitOutlinedIcon />
      </div>
      <div className="loginArtChip loginArtChipLight" title="Lighting">
        <LightbulbOutlinedIcon />
      </div>
      <div className="loginArtChip loginArtChipFridge" title="Refrigeration">
        <KitchenOutlinedIcon />
      </div>

      <div className="loginArtCard loginArtAlert">
        <span className="loginArtAlertIcon">
          <WarningAmberRoundedIcon />
        </span>
        <div>
          <div className="loginArtAlertTitle">Oven running above usual</div>
          <div className="loginArtAlertText">Make line oven drew 18% more energy today</div>
        </div>
        <span className="loginArtButton">View</span>
      </div>

      <div className="loginArtCard loginArtChart">
        <div className="loginArtLabel">Store energy today</div>
        <div className="loginArtValue">
          412 <span>kWh</span>
        </div>
        <svg viewBox="0 0 300 100" preserveAspectRatio="none" aria-hidden="true">
          <defs>
            <linearGradient id="loginArtFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#64c7f2" stopOpacity="0.45" />
              <stop offset="100%" stopColor="#64c7f2" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d={`${CHART_LINE} L300 100 L0 100 Z`} fill="url(#loginArtFill)" />
          <path d={CHART_LINE} fill="none" stroke="#184895" strokeWidth="2.5" vectorEffect="non-scaling-stroke" />
        </svg>
        <div className="loginArtAxis">
          <span>6 AM</span>
          <span>12 PM</span>
          <span>6 PM</span>
          <span>12 AM</span>
        </div>
      </div>

      <div className="loginArtCard loginArtStores">
        <span className="loginArtStoresIcon">
          <StorefrontOutlinedIcon />
        </span>
        <div>
          <div className="loginArtLabel">Stores online</div>
          <div className="loginArtValue loginArtValueSmall">
            <span className="loginArtLive" />
            All live
          </div>
        </div>
      </div>
    </div>
  );
}

export function LoginBrands() {
  return (
    <div className="loginBrands">
      <div className="loginBrandsTitle">Our brands</div>
      <div className="loginBrandsRow">
        {BRANDS.map((brand) => (
          <img key={brand.name} src={brand.logo} alt={brand.name} />
        ))}
      </div>
    </div>
  );
}
